/**
 * RESPONSIBILITY: the @Repeats control — a repeating date chosen from plain words.
 *
 * Registers with a tester + rank. The highest-ranked renderer for a schema node wins, so
 * adding a control is a registration — there is no switch on field type.
 */
import { rankWith, and, isStringControl, optionIs, type ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { RepeatPicker } from './repeat-picker';

function RepeatControlBase({ data, handleChange, path, label, errors, id }: ControlProps) {
  return (
    <div className="ctl">
      <label className="ctl-label" htmlFor={`${id}-repeat`}>{label}</label>
      <RepeatPicker
        id={`${id}-repeat`} value={typeof data === 'string' ? data : ''}
        onChange={(v) => handleChange(path, v)}
      />
      {errors && <p className="ctl-error">{errors}</p>}
    </div>
  );
}

export const repeatControl = {
  tester: rankWith(10, and(isStringControl, optionIs('widget', 'repeat'))),
  renderer: withJsonFormsControlProps(RepeatControlBase),
};
